var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"legend-tag"},[_c('div',{staticClass:"item-wrap"},_vm._l((_vm.chartData),function(item,index){return _c('div',{key:index,staticClass:"item",style:({
        marginBottom:_vm.config.marginBot+'px'
      })},[_c('span',{staticClass:"icon",style:({
          backgroundColor: _vm.config.color[index],
          width: _vm.config.tag.width +'px',
          height: _vm.config.tag.height +'px',
          borderRadius: _vm.config.tag.borderRadius
        })}),_c('span',{staticClass:"name",style:(Object.assign({}, _vm.config.textStyle,
          {fontSize: _vm.config.textStyle.fontSize +'px',
          marginLeft:'15px'}))},[_vm._v(_vm._s(item[_vm.config['xField']]))]),_c('span',{staticClass:"count",style:(Object.assign({}, _vm.config.countStyle,
          {fontSize: _vm.config.countStyle.fontSize +'px'}))},[_vm._v(_vm._s(item[_vm.config['yField']])+"%")])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }